import {
  Box,
  Input,
  Text,
  Image,
  Button,
  Checkbox,
  Spinner,
  Divider,
  Stack,
  RadioGroup,
  Radio,
  Progress,
  Skeleton,
  useToast
} from "@chakra-ui/react";
import React, { useEffect, useState, useRef, useContext } from "react";
import { Footer } from "../../components/Footer";
import { api } from "../../services/api";
import { setFinalPriceForCartBatch } from "../../services/setFinalPriceForCartBatch";
import { setFinalPriceForOrder } from "../../services/setFinalPriceForOrder";
import { calculateDeliveryPeriod } from "../../services/deliveryPeriodCalculation";
import { theme } from "../../styles/theme";
import { useAuth } from "../../Hooks/useAuth";
import { BsDash, BsPlus } from 'react-icons/bs';
import { debounce } from 'lodash'
import Navbar from "../../components/Navbar";
import { FaRegTimesCircle, FaThumbsUp, FaThumbsDown, FaRedoAlt  } from 'react-icons/fa';
import { BoozenToast } from '../../components/BoozenToast';
import { BoozenConfirmDialog, useBoozenConfirm } from '../../components/BoozenConfirm';
import { finishCustomerOrder } from "../../services/finishCustomerOrder";
import { InputMask } from '../../components/InputMask'
import { CartContext } from "../../Context/CartContext";


export function Cart() {
  const toast = useToast();
  const { confirm, confirmDialogProps } = useBoozenConfirm();
  const showToast = (type, title, description) => {
    toast({
      position: 'top',
      duration: 5000,
      isClosable: true,
      render: ({ onClose }) => (
        <BoozenToast type={type} title={title} description={description} onClose={onClose} />
      ),
    });
  };

  const [cartBatches, setCartBatches] = useState([]);
  const { user, signInUser, getUserInfo, signUpUser } = useAuth();
  const { errors } = useAuth();
  const [batches, setBatches] = useState([]);
  const [products, setProducts] = useState([]);
  const [prices, setPrices] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [userCredits, setUserCredits] = useState([]);
  const [amountAlreadyPurchased, setAmountAlreadyPurchased] = useState([]);
  const [useCredit, setUseCredit] = useState(false);
  const [CEP, setCEP] = useState("");
  const [deliveryAddress, setDeliveryAddress] = useState({});
  const [deliveryAddressNumber, setDeliveryAddressNumber] = useState("");
  const [deliveryAddressComplement, setDeliveryAddressComplement] = useState("");
  const [deliveryMethod, setDeliveryMethod] = useState("delivery");
  const [collectionAddress, setCollectionAddress] = useState({});
  const [collectionAddressCity, setCollectionAddressCity] = useState({});
  const [collectionAddressState, setCollectionAddressState] = useState({});
  const [loadingPage, setLoadingPage] = useState(true);
  const [paymentMethod, setPaymentMethod] = useState("not_selected");
  const [paymentObservations, setPaymentObservations] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [validCoupon, setValidCoupon] = useState(undefined);
  const [statusCoupon, setStatusCoupon] = useState("Não aplicado");
  const [couponKind, setCouponKind] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [useAddressFromUser, setUseAddressFromUser] = useState(false);
  const [guestCartBatches, setGuestCartBatches] = useState([]);
  const [authType, setAuthType] = useState('signUp');
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [userDocument, setUserDocument] = useState("");
  const [userName, setUserName] = useState("");
  const [userPhoneNumber, setUserPhoneNumber] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [isOrderProcessing, setIsOrderProcessing] = useState(false);
  const [deliveryStep, setDeliveryStep] = useState(true);
  const [paymentStep, setPaymentStep] = useState(false);
  const [loadingPaymentProcess, setLoadingPaymentProcess] = useState(false);
  const [guestSignupFlow, setGuestSignupFlow] = useState(false);
  const [userUpdateErrors, setUserUpdateErrors] = useState({});
  const [storedPendingPaymentId, setStoredPendingPaymentId] = useState(null);
  const [userAddress, setUserAddress] = useState({
    city: "",
    complement: "",
    neighborhood: "",
    number: "",
    postal_code: "",
    state: "",
    street: ""
  });
  const { decrementCartCounter } = useContext(CartContext);
  const {
    migrateGuestCartToUser
  } = useContext(CartContext);
  const allowedCities = [
    'Belo Horizonte',
    'Nova Lima',
    'Contagem',
    'Betim',
    'Lagoa Santa'
  ];
  const isDeliveryStepCompleted =
  !(
    (!!deliveryAddress &&
      !!deliveryAddress.logradouro &&
      !!deliveryAddressNumber) ||
    deliveryMethod === "collect"
  ) ||
  (!user &&
    authType === "signUp" &&
    (userEmail === "" ||
     userName === "" ||
     userDocument === "" ||
     userPhoneNumber === ""));


  async function fetchCartBatches() {
    setLoadingPage(true);
    if (user) {
      try {
        const response = await api.get(`/api/v1/cart_batches?user_id=${user.id}`);
        setCartBatches(response.data.cart_batches)
        setBatches(response.data.batches)
        setProducts(response.data.products)
        setPrices(response.data.prices)
        setPhotos(response.data.photos)
        setAmountAlreadyPurchased(response.data.amount_already_purchased)
        setUserCredits(response.data.user_credits)
        setCollectionAddress(response.data.collection_address)
        setCollectionAddressCity(response.data.collection_address_city)
        setCollectionAddressState(response.data.collection_address_state)
        setUserAddress(response.data.user_address)
      } catch (error) {
        console.error("Error fetching user cart:", error);
      }
    } else {
      const cartData = localStorage.getItem("guestCart");
      const guestCart = cartData ? JSON.parse(cartData) : [];
      const guestBatches = guestCart.map((item) => ({
        product_id: item.product_id,
        batch_id: item.batch_id,
        quantity: item.quantity,
        amount: parseFloat(item.amount),
      }));

      setCartBatches(guestBatches);
      const batchIds = guestBatches
        .map((item) => item.batch_id)
        .filter((batchId) => batchId && batchId.toString().trim() !== "");

      if (batchIds.length > 0) {
        try {
          const response = await api.get(
            `/api/v1/cart_batches/get_guest_cart?batch_ids=${batchIds}`
          );
          const {
            missing_batch_ids, batches, products, prices, photos,
            collection_address, collection_address_city, collection_address_state,
          } = response.data;

          if (missing_batch_ids && missing_batch_ids.length > 0) {
            const updatedGuestCart = guestCart.filter(
              (item) => !missing_batch_ids.includes(item.batch_id.toString())
            );
            showToast("warning", "Itens removidos", "Alguns produtos do seu carrinho não estão mais disponíveis e foram removidos.");
            localStorage.setItem("guestCart", JSON.stringify(updatedGuestCart));
            setCartBatches(updatedGuestCart);
          }

          setBatches(batches);
          setProducts(products);
          setPrices(prices);
          setPhotos(photos);
          setAmountAlreadyPurchased(response.data.amount_already_purchased);
          setUserCredits([]);
          if (collection_address) {
            setCollectionAddress(collection_address);
            setCollectionAddressCity(collection_address_city || {});
            setCollectionAddressState(collection_address_state || {});
          }
        } catch (error) {
          console.error("Error fetching batch/product details:", error);
        }
      }
    }
    setLoadingPage(false);
  }

  useEffect(() => {
    if (guestSignupFlow) return;
    fetchCartBatches();
  }, [user]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const pid = localStorage.getItem('pendingPaymentId');
    if (pid) setStoredPendingPaymentId(pid);
  }, []);

  function handleUseCreditChange() {
    setUseCredit(!useCredit);
  }

  const delayedQuery = useRef(
    debounce(async cartBatch => {
      const dataObject = new FormData();
      dataObject.append("cart_batch[amount]", cartBatch.amount);
      dataObject.append("cart_batch[quantity]", cartBatch.quantity);
      const response = await api.put(`/api/v1/cart_batches/${cartBatch.id}`, dataObject);
    }, 1000)
  ).current;

  function handleIncrement(cartBatch) {
    let updatedCartBatch;
    setAmountAlreadyPurchased(amountAlreadyPurchased + 1)
    const currentCartBatches = [...cartBatches]
    updatedCartBatch = currentCartBatches.find(e => e.batch_id === cartBatch.batch_id)
    ++updatedCartBatch.quantity
    const productId = batches.find(element => element.id === updatedCartBatch.batch_id).product_id
    const quantityPerBox = products.find(e => e.id === productId).quantity_per_box
    const sortedPrices = prices.filter(e => e.batch_id === updatedCartBatch.batch_id).sort((a, b) => a.unity - b.unity);
    let selectedPrice = sortedPrices[0];
    for (let i = 0; i < sortedPrices.length; i++) {
      if (updatedCartBatch.quantity >= sortedPrices[i].unity) {
        selectedPrice = sortedPrices[i];
      } else {
        break;
      }
    }
    updatedCartBatch.amount = quantityPerBox * updatedCartBatch.quantity * selectedPrice.price_per_unity
    setCartBatches(currentCartBatches);
    if (user) {
      delayedQuery(cartBatch)
    } else {
      const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
      const updatedGuestCart = guestCart.map(item =>
        item.batch_id === cartBatch.batch_id
          ? {
              ...item,
              quantity: updatedCartBatch.quantity,
              amount: updatedCartBatch.amount
          }
          : item
      );
      localStorage.setItem('guestCart', JSON.stringify(updatedGuestCart));
    }
  }

  const paymentStepDisplay = (e) => {
    e.preventDefault()
    setDeliveryStep(false)
    setPaymentStep(true)
  }

  const deliveryStepDisplay = (e) => {
    e.preventDefault()
    setDeliveryStep(true)
    setPaymentStep(false)
  }


  function handleDecrement(cartBatch) {
    if (cartBatch.quantity <= 1 ) {
      document.getElementById("button-decrement").disabled = true
      return
    }
    let updatedCartBatch;
    setAmountAlreadyPurchased(amountAlreadyPurchased - 1)
    const currentCartBatches = [...cartBatches]
    updatedCartBatch = currentCartBatches.find(e => e.batch_id === cartBatch.batch_id)
    --updatedCartBatch.quantity
    const productId = batches.find(element => element.id === updatedCartBatch.batch_id).product_id
    const quantityPerBox = products.find(e => e.id === productId).quantity_per_box
    const sortedPrices = prices.filter(e => e.batch_id === updatedCartBatch.batch_id).sort((a, b) => a.unity - b.unity);
    let selectedPrice = sortedPrices[0];
    for (let i = 0; i < sortedPrices.length; i++) {
      if (updatedCartBatch.quantity >= sortedPrices[i].unity) {
        selectedPrice = sortedPrices[i];
      } else {
        break;
      }
    }
    updatedCartBatch.amount = quantityPerBox * updatedCartBatch.quantity * selectedPrice.price_per_unity
    setCartBatches(currentCartBatches)
    if (user) {
      delayedQuery(cartBatch)
    } else {
      const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
      const updatedGuestCart = guestCart.map(item =>
        item.batch_id === cartBatch.batch_id
          ? {
              ...item,
              quantity: updatedCartBatch.quantity,
              amount: updatedCartBatch.amount
          }
          : item
      );
      localStorage.setItem('guestCart', JSON.stringify(updatedGuestCart));
    }
  }

  // (no redirect on signIn — inline form handles it)

  const updateUser = async (userName, userDocument, userPhoneNumber) => {
    let cleanedDocumentNumber =  userDocument.replace(/[.-\s]/g, '');
    let cleanedPhoneNumber =  userPhoneNumber.replace(/\D/g, '');
    const formData = new FormData();
    if (userName !== "") {
      formData.append("user[full_name]", userName);
    }
    if (userDocument !== "") {
      formData.append("user[document_number]", cleanedDocumentNumber);
    }
    if (userPhoneNumber !== "") {
      formData.append("user[phone_number]", cleanedPhoneNumber);
    }

    const response = await api.put(`/api/v1/users/${user.id}`, formData, {
      headers: {
        'Content-Type': "multipart/form-data",
      },
    });

    // if (response.data?.errors) {
    //   throw response;
    // }

    if (response.data.message === "Usuário atualizado com sucesso") {
      showToast("success", "Dados atualizados!", "Seus dados foram salvos com sucesso.");
    } else {
      showToast("error", "Algo deu errado", "Não foi possível salvar os dados. Tente novamente.");
    }
  };


  function generateRandomUserPassword(length = 12) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  }

  const googleSignInRef = useRef(null);

  // ─── Inline sign-in (no page redirect) ────────────────────────────────────
  const handleInlineSignIn = async () => {
    if (!userEmail || !userPassword) {
      showToast("info", "Preencha os dados", "Informe seu email e senha para continuar.");
      return;
    }
    setIsProcessing(true);
    try {
      // 1. Sign in and store tokens
      const response = await api.post("/api/v1/auth/sign_in", {
        email: userEmail,
        password: userPassword,
      });
      localStorage.setItem("@app/token", response.headers["access-token"]);
      localStorage.setItem("@app/uid", response.headers["uid"]);
      localStorage.setItem("@app/client", response.headers["client"]);
      localStorage.setItem("@app/expiry", response.headers["expiry"]);

      // 2. Fetch fresh user data from the API (user context is still stale here)
      const meRes = await api.get("/api/v1/users/me");
      const loggedInUser = meRes.data;
      localStorage.setItem("userId", loggedInUser.id);
      localStorage.setItem("userPhoto", loggedInUser.user_photo || "");

      // 3. Immediately migrate any guest cart items so the cart shows everything
      const guestCartRaw = localStorage.getItem("guestCart");
      if (guestCartRaw) {
        const guestCart = JSON.parse(guestCartRaw);
        if (guestCart.length > 0) {
          await migrateGuestCartToUser(loggedInUser);
          // migrateGuestCartToUser already removes the guestCart from localStorage
        }
      }

      // 4. Update auth context → triggers fetchCartBatches with merged items
      await getUserInfo();

      showToast("success", "Login realizado!", "Bem-vindo de volta. Seu carrinho foi carregado.");
    } catch {
      showToast("error", "Dados incorretos", "Verifique seu email e senha e tente novamente.");
    } finally {
      setIsProcessing(false);
    }
  };

  // ─── Google sign-in (no page redirect) ────────────────────────────────────
  useEffect(() => {
    if (user || authType !== "signIn") return;
    const onGoogleToken = async (credential) => {
      setIsProcessing(true);
      try {
        const res = await api.get(`/api/v1/users/sign_in_with_google?id_token=${credential}`);
        if (res.status !== 200) throw new Error();
        const tokens = res.data.tokens;
        localStorage.setItem("@app/token", tokens["access-token"]);
        localStorage.setItem("@app/uid", tokens["uid"]);
        localStorage.setItem("@app/client", tokens["client"]);
        localStorage.setItem("@app/expiry", tokens["expiry"]);
        const meRes = await api.get("/api/v1/users/me");
        const loggedInUser = meRes.data;
        localStorage.setItem("userId", loggedInUser.id);
        localStorage.setItem("userPhoto", loggedInUser.user_photo || "");
        const guestCartRaw = localStorage.getItem("guestCart");
        if (guestCartRaw) {
          const guestCart = JSON.parse(guestCartRaw);
          if (guestCart.length > 0) await migrateGuestCartToUser(loggedInUser);
        }
        await getUserInfo();
        showToast("success", "Login realizado!", "Bem-vindo de volta. Seu carrinho foi carregado.");
      } catch {
        showToast("error", "Erro no login com Google", "Não foi possível entrar com o Google. Tente novamente.");
      } finally {
        setIsProcessing(false);
      }
    };
    const init = () => {
      if (!window.google?.accounts) return;
      window.google.accounts.id.initialize({
        client_id: "480318445952-v2iilvljfmm9jk2l9c1ldi66fkjfh06f.apps.googleusercontent.com",
        callback: (r) => onGoogleToken(r.credential),
      });
      if (googleSignInRef.current) {
        window.google.accounts.id.renderButton(googleSignInRef.current, {
          theme: "outline", size: "large", width: googleSignInRef.current.offsetWidth || 340,
        });
      }
    };
    if (window.google?.accounts) {
      init();
    } else {
      const interval = setInterval(() => { if (window.google?.accounts) { clearInterval(interval); init(); } }, 150);
      return () => clearInterval(interval);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authType, user]);

  const handleFinishOrder = async (e) => {
    e.preventDefault();
    setLoadingPaymentProcess(true)

    // Update user data if profile is incomplete (must happen before validations)
    if (user && (user.full_name === "" || user.document_number === "" || user.phone_number === "")) {
      try {
        await updateUser(userName, userDocument, userPhoneNumber);
      } catch (error) {
        if (error.response && error.response.data.errors) {
          setUserUpdateErrors(error.response.data.errors);
        } else {
          showToast("error", "Erro", "Ocorreu um erro ao atualizar dados do usuário. Tente novamente.");
        }
        setDeliveryStep(true);
        setPaymentStep(false);
        setLoadingPaymentProcess(false)
        return
      }
    }

    if (deliveryMethod === "") {
      showToast("info", "Quase lá!", "Escolha um método de recebimento para continuar.");
      setLoadingPaymentProcess(false)
      return;
    }

    if (paymentMethod === "not_selected") {
      showToast("info", "Quase lá!", "Escolha um método de pagamento para continuar.");
      setLoadingPaymentProcess(false)
      return;
    }

    if (deliveryMethod === "delivery" && (deliveryAddress.logradouro === "" || deliveryAddressNumber === "" || deliveryAddress.bairro === "" || deliveryAddress.localidade === "" || deliveryAddress.uf === "" || deliveryAddress.cep === "")) {
      showToast("info", "Quase lá!", "Preencha o endereço de entrega completo antes de continuar.");
      setLoadingPaymentProcess(false)
      return;
    }

    // Guest: validate personal fields
    if (!user && authType === 'signUp') {
      if (userEmail === "" || userName === "" || userDocument === "" || userPhoneNumber === "") {
        showToast("info", "Quase lá!", "Preencha todos os campos pessoais obrigatórios antes de continuar.");
        setLoadingPaymentProcess(false);
        return;
      }
    }

    // Guest who chose "signIn" but didn't actually sign in yet
    if (!user && authType === 'signIn') {
      showToast("info", "Faça login primeiro", "Entre na sua conta antes de finalizar o pedido.");
      setLoadingPaymentProcess(false);
      return;
    }

    // All validations passed — ask for final confirmation
    const confirmed = await confirm({
      title: "Confirmar pedido",
      description: `Método de pagamento: ${paymentMethod === "pix" ? "PIX 💠" : "Cartão de crédito 💳"} · Entrega: ${deliveryMethod === "collect" ? "Retirada na loja" : "2 a 8 dias úteis"}. Deseja finalizar?`,
      confirmLabel: "Fazer pedido",
      cancelLabel: "Voltar",
      icon: "🛒",
    });
    if (!confirmed) {
      setLoadingPaymentProcess(false);
      return;
    }

    // Post-confirmation: three paths depending on user state
    if (!user) {
      // Guest checkout: create account AFTER user confirmed, then migrate cart + process order
      localStorage.setItem("signup_origin", "checkout");
      const signedUp = await signUpUser(userEmail, generateRandomUserPassword(), userName, userDocument, userPhoneNumber);
      if (!signedUp) {
        // signUpUser already set field-level errors; the errors useEffect resets the UI
        setLoadingPaymentProcess(false);
        return;
      }
      // signUpUser called getUserInfo() → user state will be set on next render
      // setGuestSignupFlow triggers the migrateCart effect which runs migration then setIsOrderProcessing
      setGuestSignupFlow(true);
    } else if (localStorage.getItem("guestCart")) {
      // Already logged in but has leftover guest items that weren't merged yet
      setGuestSignupFlow(true); // migration effect → then setIsOrderProcessing
    } else {
      // Fully logged-in user, clean cart → process order immediately
      setIsOrderProcessing(true);
    }
  };

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      setDeliveryStep(true);
      setPaymentStep(false);
      setLoadingPaymentProcess(false)
    }
  }, [errors]);

  useEffect(() => {
    const migrateCart = async () => {
      if (
        guestSignupFlow &&
        user &&
        localStorage.getItem("guestCart")
      ) {
        const success = await migrateGuestCartToUser(user);

        if (success) {
          console.log("cartBatches checkout useEffect Mirate", cartBatches);

          const response = await api.get(
            `/api/v1/cart_batches?user_id=${user.id}`
          );

          setCartBatches(response.data.cart_batches);

          setIsOrderProcessing(true);
        }
      }
    };

    migrateCart();
  }, [user, guestSignupFlow]);


  useEffect(() => {
    const processOrder = async () => {
      if (user && isOrderProcessing && !isProcessing) {
        setIsProcessing(true);
        try {
          console.log("cartBatches  useEffect finish", cartBatches);
          const result = await finishCustomerOrder(
            user,
            cartBatches,
            useCredit,
            userCredits,
            deliveryMethod,
            paymentMethod,
            paymentObservations,
            deliveryAddress,
            deliveryAddressNumber,
            deliveryAddressComplement,
            couponDiscount,
            couponKind,
            validCoupon,
            products,
            batches
          );

          if (result && result.success) {
            const items = cartBatches.map((cartItem) => ({
              item_id: cartItem.product_id,
              price: cartItem.amount,
              quantity: cartItem.quantity
            }));
            if (window && window.gtag) {
              window.gtag("event", "begin_checkout", {
                value: result.totalPrice.toFixed(2),
                currency: "BRL",
                items
              });
            }
            localStorage.removeItem('guestCart');
            window.location = `/pagamentos/${result.paymentId}`;
          } else if (result) {
            console.error("Order processing failed:", result.message);
          }
        } catch (error) {
          console.error("Error processing order:", error);
        } finally {
          setIsProcessing(false);
          setIsOrderProcessing(false);
          setLoadingPaymentProcess(false)
        }
      }
    };

    if (isOrderProcessing) {
      processOrder();
    }
  }, [user, isOrderProcessing]);


  async function hendleRemoveCartBatch(e, cartBatch) {
    e.preventDefault()
    const ok = await confirm({
      title: "Remover produto",
      description: "Deseja remover este produto do carrinho?",
      confirmLabel: "Remover",
      cancelLabel: "Cancelar",
      danger: true,
      icon: "🗑️",
    });
    if (!ok) return;
    const userId = localStorage.getItem('userId');
    const matchingBatch = batches.find(batch => batch.id === cartBatch.batch_id)
    decrementCartCounter();
    if (matchingBatch) {
      const matchingProduct = products.find(product => product.id === matchingBatch.product_id);
      if (matchingProduct) {
          window.gtag('event', 'remove_from_cart', {
            currency: "BRL",
            value: cartBatch.amount,
            'items': [{
              'item_name': matchingProduct.name,
              'item_id': matchingProduct.id,
              'price': cartBatch.amount,
              'quantity': cartBatch.quantity
            }]
          });
        } else {
          console.error('Matching product not found.');
        }
      } else {
        console.error('Matching batch not found.');
      }
      if (user) {
        try {
          const response = await api.delete(`/api/v1/cart_batches/${cartBatch.id}`);
          if (response.status === 204) {
            const updatedBatches = cartBatches.filter(batch => batch.id !== cartBatch.id);
            setCartBatches(updatedBatches);
            showToast("success", "Produto removido", "O item foi removido do carrinho.");
          } else {
            showToast("error", "Algo deu errado", "Não foi possível remover o produto. Tente novamente.");
          }
        } catch (error) {
          console.error('Error removing cart batch:', error);
          return false;
        }
      } else {
        try {
          const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
          const updatedGuestCart = guestCart.filter(item => item.batch_id !== cartBatch.batch_id);
          localStorage.setItem('guestCart', JSON.stringify(updatedGuestCart));
          updateCartState(cartBatch);
          showToast("success", "Produto removido", "O item foi removido do carrinho.");
        } catch (error) {
          console.error('Error removing cart batch:', error);
          return false;
        }
      }
  }

  function updateCartState(cartBatch) {
    const updatedCartBatches = cartBatches.filter(item => item.batch_id !== cartBatch.batch_id);
    console.log(updatedCartBatches)
    setCartBatches(updatedCartBatches);
    const removedProductBatch = batches.find(batch => batch.id === cartBatch.batch_id);
    if (removedProductBatch) {
      const updatedProducts = products.filter(product => product.id !== removedProductBatch.product_id);
      setProducts(updatedProducts);
      const updatedBatches = batches.filter(batch => batch.id !== cartBatch.batch_id);
      setBatches(updatedBatches);
    }
  }

  async function fetchCEP(e) {
    e.preventDefault();
    try {
      const response = await fetch(`https://viacep.com.br/ws/${CEP}/json/`);
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }

      const data = await response.json();
      console.log(data);
      if (
        data.localidade !== 'Belo Horizonte' &&
        data.localidade !== 'Nova Lima' &&
        data.localidade !== 'Contagem' &&
        data.localidade !== 'Betim' &&
        data.localidade !== 'Lagoa Santa'
      ) {
        showToast("error", "CEP não atendido", "Entregas somente para BH e região metropolitana.");
        setDeliveryAddress({});
        return;
      }
      setDeliveryAddress(data);
    } catch (error) {
      showToast("error", "CEP inválido", "Erro ao buscar o CEP. Verifique o formato e tente novamente.");
      setDeliveryAddress({});
    }
  }

  function handleDeliveryMethod(value) {
    if (cartBatches.length === 0) {
      showToast("info", "Carrinho vazio", "Adicione produtos antes de escolher o método de entrega.");
      return
    }
    setDeliveryMethod(value)
  }

  function handlePaymentMethod(value) {
    setPaymentMethod(value)
  }

  function handleUseUserAddressForDelivery(event) {
    const isChecked = event.target.checked;
    setUseAddressFromUser(isChecked);
    if (isChecked) {
      if (
        userAddress.city !== "" &&
        userAddress.complement !== "" &&
        userAddress.neighborhood !== "" &&
        userAddress.number !== "" &&
        userAddress.postal_code !== "" &&
        userAddress.state !== "" &&
        userAddress.street !== ""
      ) {
        setDeliveryAddress({
          localidade: userAddress.city,
          bairro: userAddress.neighborhood,
          cep: userAddress.postal_code,
          uf: userAddress.state,
          logradouro: userAddress.street
        });
        setDeliveryAddressNumber(userAddress.number);
        setDeliveryAddressComplement(userAddress.complement);
      }
    } else {
      setDeliveryAddress({});
      setDeliveryAddressNumber('');
      setDeliveryAddressComplement('');
    }
  }


  function areAllFieldsFilled(userAddress) {
    return Object.entries(userAddress).every(([key, value]) => {
      if (key === 'complement') {
        return true;
      }
      if (key === 'city') {
        return allowedCities.includes(value.trim());
      }
      return value.trim() !== '';
    });
  }

  const isAllUserAddressFieldsFilled = areAllFieldsFilled(userAddress);




  useEffect(() => {
    async function validateCoupon() {
      if (couponCode !== "") {
        // const response = await api.get(`/validate_coupon?coupon_code=${couponCode}&user_id=${user.id}`);
        const userId = user?.id;

        const response = await api.get(
          `/validate_coupon?coupon_code=${couponCode}${
            userId ? `&user_id=${userId}` : ""
          }`
        );
        setValidCoupon(response.data);

        const { result, error, discount, message, discount_kind } = response.data;

        if (result) {
          setStatusCoupon(message);
          setCouponKind(discount_kind);
          setCouponDiscount(discount);
        } else {
          setStatusCoupon(error);
          setCouponDiscount(0);
        }
      } else {
        setValidCoupon(undefined);
        setStatusCoupon("Não aplicado");
        setCouponDiscount(0);
      }
    }

    validateCoupon();
  }, [couponCode]);

  const now = new Date();
  const dayOfWeek = now.getDay();
  const currentHour = now.getHours();


  const totalCartAmount = cartBatches.reduce((acc, batch) => acc + batch.amount, 0);
  const percentageOf120 = (totalCartAmount * 100) / 120;
  const amountLeft = 120 - totalCartAmount;
  let colorScheme;

  if (percentageOf120 < 25) {
    colorScheme = 'red';
  } else if (percentageOf120 < 75) {
    colorScheme = 'yellow';
  } else {
    colorScheme = 'green';
  }

  return (
    <Box bg="#f8f8f8" minH="100vh">
      <BoozenConfirmDialog {...confirmDialogProps} />
      {(guestSignupFlow || isOrderProcessing) && (
        <Box
          position="fixed" inset="0" zIndex="2000"
          bg="rgba(255,255,255,0.92)"
          display="flex" flexDir="column" alignItems="center" justifyContent="center"
          gap="20px"
        >
          <Spinner size="xl" color="#004a33" thickness="3px" speed="0.7s" />
          <Text fontSize="15px" fontWeight="700" color="#004a33">
            {guestSignupFlow ? "Criando sua conta e preparando pedido…" : "Processando pedido…"}
          </Text>
        </Box>
      )}
      <Navbar />
      <Box
        bg="#f8f8f8"
        borderRadius="24px"
        pt={{ base: "120px", md: "160px" }}
        pb={{ base: "24px", md: "32px" }}
        px={{ base: "16px", md: "48px" }}
        mb={0}
      >
        <Text
          fontSize="12px"
          textTransform="uppercase"
          color="gray.500"
          fontWeight="700"
        >
          Checkout Seguro
        </Text>

        <Text
          fontSize={{ base: "28px", md: "36px" }}
          fontWeight="900"
          color={theme.colors.primaryGreen}
        >
          Finalize sua compra
        </Text>

        <Text color="gray.600">
          Confira seus dados e conclua seu pedido.
        </Text>
      </Box>
      {storedPendingPaymentId && (
        <Box
          maxW="1200px"
          mx="auto"
          px={{ base: "16px", md: "32px" }}
          mt={4}
          p={4}
          bg="orange.50"
          borderRadius="16px"
          border="1px solid"
          borderColor="orange.300"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          gap={3}
        >
          <Box>
            <Text fontWeight="700" color="orange.700" fontSize="sm">
              Você tem um pagamento PIX pendente
            </Text>
            <Text fontSize="xs" color="orange.600">
              Finalize o pagamento anterior antes de criar um novo pedido.
            </Text>
          </Box>
          <Button
            size="sm"
            bg={theme.colors.primaryGreen}
            color="white"
            borderRadius="12px"
            flexShrink={0}
            onClick={() => window.location.href = `/pagamentos/${storedPendingPaymentId}`}
          >
            Continuar
          </Button>
        </Box>
      )}

      <Box
        maxW="1200px"
        mx="auto"
        px={{ base: "16px", md: "32px" }}
        pt={4}
        pb={{ base: "48px", md: "64px" }}
      >
        <Box
          background="transparent"
        >
          <Box
            display={"flex"}
            flexDirection={{base: 'column', md: 'row'}}
            justifyContent={"space-between"}
            width={{base: '100%', md: '100%'}}
            margin={{base: 'auto', md: ''}}
            minHeight={{base: '90vh', md: ''}}
            gap="12px"
          >
            <Box width={{ base: "100%", lg: "68%" }} order={{base: '2', md: '1'}}>
              <Box
                borderRadius="16px"
                border={`1px solid rgba(0, 74, 51, 0.08)`}
                boxShadow="0 4px 16px rgba(0, 74, 51, 0.08)"
                marginBottom={{base: '30px', md: '0px'}}
                bg="white"
                overflow="hidden"
                transition="all 0.3s ease"
                _hover={{
                  boxShadow: "0 8px 24px rgba(0, 74, 51, 0.12)",
                  borderColor: "rgba(0, 74, 51, 0.16)"
                }}
              >
                {deliveryStep && (<>

                  <Box
                    bg={`linear-gradient(135deg, ${theme.colors.primaryGreen} 0%, rgba(0, 74, 51, 0.95) 100%)`}
                    p="16px 20px"
                    borderBottom="none"
                  >
                    <Text
                      fontSize="20px"
                      color={theme.colors.primaryOrange}
                      fontWeight="900"
                    >
                      Dados da Entrega
                    </Text>
                  </Box>

                  {!user && (<Box padding="20px">
                    <Box border={`1px solid rgba(0, 74, 51, 0.08)`} boxShadow="0 2px 8px rgba(0, 74, 51, 0.04)" p="20px" my="12px" borderRadius="12px" bg="rgba(0, 74, 51, 0.02)">
                      <Text fontSize="18px" fontWeight="500" mb="20px">Dados pessoais</Text>
                      <Box my="5px">
                        <RadioGroup onChange={setAuthType} value={authType}>
                          <Stack direction="row" justifyContent="space-between">
                            <Radio value="signIn">Já tenho uma conta</Radio>
                            <Radio value="signUp">Cadastrar</Radio>
                          </Stack>
                        </RadioGroup>
                      </Box>
                      {authType === "signIn" ? (
                        /* ── Inline sign-in (no redirect) ──────────────────── */
                        <Box mt="14px">
                          <Box display={{ base: "block", md: "flex" }} gap={4} mb="10px">
                            <Box width="100%">
                              <Input
                                placeholder="E-mail"
                                type="email"
                                value={userEmail}
                                onChange={(e) => setUserEmail(e.target.value)}
                                h="52px"
                                borderRadius="14px"
                                mb={{ base: "10px", md: "0" }}
                                _focus={{ borderColor: "#fc8f04", boxShadow: "0 0 0 1px #fc8f04" }}
                              />
                            </Box>
                            <Box width="100%">
                              <Input
                                placeholder="Senha"
                                type="password"
                                value={userPassword}
                                onChange={(e) => setUserPassword(e.target.value)}
                                h="52px"
                                borderRadius="14px"
                                _focus={{ borderColor: "#fc8f04", boxShadow: "0 0 0 1px #fc8f04" }}
                              />
                            </Box>
                          </Box>
                          <Button
                            onClick={handleInlineSignIn}
                            isLoading={isProcessing}
                            loadingText="Entrando..."
                            w="100%"
                            h="52px"
                            borderRadius="14px"
                            bg="#004a33"
                            color="#fc8f04"
                            fontWeight="800"
                            fontSize="15px"
                            _hover={{ opacity: 0.9 }}
                          >
                            Entrar na conta
                          </Button>
                          <Text
                            mt="10px"
                            fontSize="12px"
                            color="gray.500"
                            textAlign="center"
                          >
                            Esqueceu a senha?{" "}
                            <Box
                              as="a"
                              href="/recuperar_senha"
                              color="#004a33"
                              fontWeight="700"
                              textDecoration="underline"
                            >
                              Recuperar acesso
                            </Box>
                          </Text>
                          <Box display="flex" alignItems="center" gap="10px" my="14px">
                            <Box flex={1} h="1px" bg="rgba(0,74,51,.12)" />
                            <Text fontSize="11px" color="gray.400" fontWeight="700" letterSpacing="0.05em">OU</Text>
                            <Box flex={1} h="1px" bg="rgba(0,74,51,.12)" />
                          </Box>
                          <Box ref={googleSignInRef} w="100%" display="flex" justifyContent="center" />
                        </Box>
                      ) : (
                        /* ── New account form ───────────────────────────────── */
                        <>
                          <Box
                            margin="10px 0"
                            display={{base: "block", md: "flex"}}
                            gap={5}
                          >
                            <Box width="100%">
                              <Input
                                placeholder="E-mail"
                                onChange={(e) => setUserEmail(e.target.value)}
                                h="56px"
                                borderRadius="14px"
                                marginBottom="10px"
                                autoComplete="email"
                                _focus={{ borderColor: "#fc8f04", boxShadow: "0 0 0 1px #fc8f04" }}
                              />
                              {errors.email && <Text color="red.500" fontSize="sm">{errors.email[0] === "is not an email" ? "Email inválido" : errors.email[0]}</Text>}
                            </Box>
                            <Box width="100%">
                              <Input
                                id="name-input"
                                placeholder="Nome Completo"
                                onChange={(e) => setUserName(e.target.value)}
                                h="56px"
                                borderRadius="14px"
                                marginBottom="10px"
                                autoComplete="name"
                                _focus={{ borderColor: "#fc8f04", boxShadow: "0 0 0 1px #fc8f04" }}
                              />
                              {errors.full_name && <Text color="red.500" fontSize="sm">{errors.full_name[0]}</Text>}
                            </Box>
                          </Box>

                          <Box
                            margin="10px 0"
                            display={{base: "block", md: "flex"}}
                            gap={5}
                          >
                            <Box width="100%">
                              <InputMask maskType="cpf" placeholder="CPF" setUserDocument={setUserDocument} marginTop="10px"/>
                              {errors.document_number && <Text color="red.500" fontSize="sm">{errors.document_number[0]}</Text>}
                            </Box>
                            <Box width="100%" marginTop={{base: "10px", md: "0px"}}>
                              <InputMask maskType="phone" placeholder="Celular" setUserPhoneNumber={setUserPhoneNumber}/>
                              {errors.phone_number && <Text color="red.500" fontSize="sm">{errors.phone_number[0]}</Text>}
                            </Box>
                          </Box>
                        </>
                      )}
                    </Box>
                  </Box>)}
                  {user && (user.document_number === "" || user.phone_number === "" || user.full_name === "" ) && (<Box padding="20px">
                    <Box border={`1px solid rgba(0, 74, 51, 0.08)`} boxShadow="0 2px 8px rgba(0, 74, 51, 0.04)" p="20px" my="12px" borderRadius="12px" bg="rgba(0, 74, 51, 0.02)">

                      <Text fontSize="18px" fontWeight="500" mb="20px">Dados pessoais</Text>
                      <Box>
                        <Box
                          margin="10px 0"
                          display="flex"
                          gap={5}
                        >
                          {user.full_name === "" && (<>
                            <Box width="100%">
                              <Input
                                id="name-input"
                                placeholder="Nome Completo"
                                onChange={(e) => setUserName(e.target.value)}
                                h="56px"
                                mb="2"
                                borderRadius="14px"
                                marginBottom="10px"
                                autoComplete="current-email"
                                _focus={{
                                  borderColor: "#fc8f04",
                                  boxShadow: "0 0 0 1px #fc8f04"
                                }}
                              />
                              {errors.full_name && <Text color="red.500" fontSize="sm">{errors.full_name[0]}</Text>}
                            </Box>
                          </>)}
                          {user.document_number === "" && (<>
                            <Box width="100%">
                              <InputMask maskType="cpf" placeholder="CPF" setUserDocument={setUserDocument} marginTop="10px"/>
                              {errors.document_number && <Text color="red.500" fontSize="sm">{errors.document_number[0]}</Text>}
                            </Box>
                          </>)}
                          {user.phone_number === "" && (<>
                            <Box width="100%">
                              <InputMask maskType="phone" placeholder="Celular" setUserPhoneNumber={setUserPhoneNumber}/>
                              {errors.phone_number && <Text color="red.500" fontSize="sm">{errors.phone_number[0]}</Text>}
                            </Box>
                          </>)}
                        </Box>
                      </Box>
                    </Box>
                  </Box>)}
                  <Box padding="20px">
                    <Box border={`1px solid rgba(0, 74, 51, 0.08)`} boxShadow="0 2px 8px rgba(0, 74, 51, 0.04)" p="20px" my="12px" borderRadius="12px" bg="rgba(0, 74, 51, 0.02)">
                      <Text
                        fontSize="18px" fontWeight="500" mb="5px"
                      >
                        Logística
                      </Text>
                      <Box>
                        <Box display="grid" gridTemplateColumns={{ base: "1fr", md: "1fr 1fr" }} gap="10px" mt={2} mb={1}>
                          <Box
                            as="button"
                            onClick={() => handleDeliveryMethod('delivery')}
                            border={deliveryMethod === 'delivery' ? "2px solid #004a33" : "1.5px solid rgba(0,74,51,.15)"}
                            bg={deliveryMethod === 'delivery' ? "rgba(0,74,51,.04)" : "white"}
                            borderRadius="14px"
                            p={4}
                            textAlign="left"
                            cursor="pointer"
                            transition="all 0.15s"
                            _hover={{ borderColor: "#004a33", bg: "rgba(0,74,51,.03)" }}
                          >
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                              <Box display="flex" alignItems="center" gap={2}>
                                <Text fontSize="18px">🚚</Text>
                                <Text fontWeight="800" fontSize="14px" color="#004a33">Entrega</Text>
                              </Box>
                              {deliveryMethod === 'delivery' && (
                                <Box w="18px" h="18px" borderRadius="50%" bg="#004a33"
                                  display="flex" alignItems="center" justifyContent="center">
                                  <Text color="#fc8f04" fontSize="9px" fontWeight="900">✓</Text>
                                </Box>
                              )}
                            </Box>
                            <Text fontSize="12px" color="gray.500" textAlign="left">BH e Região Metropolitana</Text>
                            <Text fontSize="12px" fontWeight="700" color="#004a33" mt={1} textAlign="left">2 a 8 dias úteis</Text>
                          </Box>
                          <Box
                            as="button"
                            onClick={() => handleDeliveryMethod('collect')}
                            border={deliveryMethod === 'collect' ? "2px solid #004a33" : "1.5px solid rgba(0,74,51,.15)"}
                            bg={deliveryMethod === 'collect' ? "rgba(0,74,51,.04)" : "white"}
                            borderRadius="14px"
                            p={4}
                            textAlign="left"
                            cursor="pointer"
                            transition="all 0.15s"
                            _hover={{ borderColor: "#004a33", bg: "rgba(0,74,51,.03)" }}
                          >
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                              <Box display="flex" alignItems="center" gap={2}>
                                <Text fontSize="18px">🏪</Text>
                                <Text fontWeight="800" fontSize="14px" color="#004a33">Retirada</Text>
                              </Box>
                              {deliveryMethod === 'collect' && (
                                <Box w="18px" h="18px" borderRadius="50%" bg="#004a33"
                                  display="flex" alignItems="center" justifyContent="center">
                                  <Text color="#fc8f04" fontSize="9px" fontWeight="900">✓</Text>
                                </Box>
                              )}
                            </Box>
                            <Text fontSize="12px" color="gray.500" textAlign="left">No ponto de coleta</Text>
                            <Text fontSize="12px" fontWeight="700" color="#004a33" mt={1} textAlign="left">A partir de 8 dias úteis</Text>
                          </Box>
                        </Box>
                        {(deliveryMethod === "delivery") && (
                          <Box marginTop=''>
                            {isAllUserAddressFieldsFilled && (
                              <Checkbox
                                colorScheme='green'
                                value="useAdressForDelivery"
                                borderColor={theme.colors.lightGray}
                                onChange={(e) => handleUseUserAddressForDelivery(e)}
                              >
                                Usar meu endereço
                              </Checkbox>
                            )}
                            <Text
                              fontSize="18px" fontWeight="500" mb="5px"
                            >
                              Endereço
                            </Text>
                            <Box display='flex' gap='10px'>
                              <Input
                                placeholder="Digite o CEP"
                                borderColor={theme.colors.lightGray}
                                type="text"
                                id="cep-input"
                                h="56px"
                                mb="2"
                                borderRadius="14px"
                                marginBottom="10px"
                                autoComplete="full-name"
                                _focus={{
                                  borderColor: "#fc8f04",
                                  boxShadow: "0 0 0 1px #fc8f04"
                                }}
                                onChange={(e) => setCEP(e.target.value.replace(/[.-]/g, ''))}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    fetchCEP(e);
                                  }
                                }}
                              />
                              <Button
                                onClick={(e) => fetchCEP(e)}
                                background='transparent'
                                border={`1px solid ${theme.colors.lightGray}`}
                                _hover={{
                                  background: theme.colors.primaryGreen,
                                  color: 'white'
                                }}
                              >Buscar</Button>
                            </Box>
                            <Box
                              margin="10px 0"
                              display="flex"
                              gap={5}
                            >
                              <Input
                                placeholder="Rua"
                                value={deliveryAddress.logradouro || ''}
                                disabled
                                h="56px"
                                mb="2"
                                borderRadius="14px"
                                marginBottom="10px"
                                autoComplete="full-name"
                                _focus={{
                                  borderColor: "#fc8f04",
                                  boxShadow: "0 0 0 1px #fc8f04"
                                }}
                              />
                              <Input
                                placeholder="Número"
                                type="number"
                                h="56px"
                                mb="2"
                                borderRadius="14px"
                                marginBottom="10px"
                                autoComplete="full-name"
                                _focus={{
                                  borderColor: "#fc8f04",
                                  boxShadow: "0 0 0 1px #fc8f04"
                                }}
                                onChange={(e) => setDeliveryAddressNumber(e.target.value)}
                              />
                            </Box>
                            <Box
                              margin="10px 0"
                              display="flex"
                              gap={5}
                            >
                              <Input
                                placeholder="Complemento"
                                onChange={(e) => setDeliveryAddressComplement(e.target.value)}
                                h="56px"
                                mb="2"
                                borderRadius="14px"
                                marginBottom="10px"
                                autoComplete="full-name"
                                _focus={{
                                  borderColor: "#fc8f04",
                                  boxShadow: "0 0 0 1px #fc8f04"
                                }}
                              />
                              <Input
                                placeholder="Bairro"
                                value={deliveryAddress.bairro || ''}
                                disabled
                                h="56px"
                                mb="2"
                                borderRadius="14px"
                                marginBottom="10px"
                                autoComplete="full-name"
                                _focus={{
                                  borderColor: "#fc8f04",
                                  boxShadow: "0 0 0 1px #fc8f04"
                                }}
                              />
                            </Box>
                            <Box
                              margin="10px 0"
                              display="flex"
                              gap={5}
                            >
                              <Input
                                placeholder="Cidade"
                                value={deliveryAddress.localidade || ''}
                                disabled
                                h="56px"
                                mb="2"
                                borderRadius="14px"
                                marginBottom="10px"
                                autoComplete="full-name"
                                _focus={{
                                  borderColor: "#fc8f04",
                                  boxShadow: "0 0 0 1px #fc8f04"
                                }}
                              />
                              <Input
                                placeholder="Estado"
                                value={deliveryAddress.uf || ''}
                                disabled
                                h="56px"
                                mb="2"
                                borderRadius="14px"
                                marginBottom="10px"
                                autoComplete="full-name"
                                _focus={{
                                  borderColor: "#fc8f04",
                                  boxShadow: "0 0 0 1px #fc8f04"
                                }}
                              />
                            </Box>
                          </Box>
                        )}

                        {deliveryMethod === "collect" && (
                          <Box mt="14px" p="16px" borderRadius="14px" bg="rgba(0,74,51,.03)" border="1px solid rgba(0,74,51,.10)">
                            <Box display="flex" alignItems="center" gap="10px" mb="10px">
                              <Text fontSize="20px">🏪</Text>
                              <Text fontWeight="800" fontSize="14px" color="#004a33">Local de Retirada</Text>
                            </Box>
                            {collectionAddress?.address_street ? (
                              <Box>
                                <Text fontSize="13px" color="gray.700" fontWeight="600">
                                  {collectionAddress.address_street}, nº {collectionAddress.address_number}
                                  {collectionAddress.address_complement ? `, ${collectionAddress.address_complement}` : ""}
                                  {collectionAddress.address_neighborhood ? ` — ${collectionAddress.address_neighborhood}` : ""}
                                </Text>
                                <Text fontSize="12px" color="gray.500" mt="3px">
                                  {collectionAddressCity?.name || ""}
                                  {collectionAddressState?.acronym ? ` — ${collectionAddressState.acronym}` : ""}
                                  {collectionAddress.address_postal_code ? ` · CEP ${collectionAddress.address_postal_code}` : ""}
                                </Text>
                                <Text fontSize="11px" fontWeight="700" color="#004a33" mt="10px">
                                  ⏱ Disponível a partir de 8 dias úteis após a confirmação
                                </Text>
                              </Box>
                            ) : (
                              <Text fontSize="13px" color="gray.600">
                                O endereço do ponto de retirada será informado por e-mail após a confirmação do pedido.
                              </Text>
                            )}
                          </Box>
                        )}

                        {(
                            !!deliveryAddress.logradouro &&
                            !!deliveryAddress.bairro &&
                            !!deliveryAddress.localidade &&
                            !!deliveryAddress.uf &&
                            !!deliveryAddress.cep && deliveryAddressNumber !== "") &&
                          (
                            <Box mt="14px" p="16px" borderRadius="14px" bg="rgba(0,74,51,.03)" border="1px solid rgba(0,74,51,.10)">
                              <Box display="flex" alignItems="center" gap="10px" mb="10px">
                                <Text fontSize="20px">🏠</Text>
                                <Text fontWeight="800" fontSize="14px" color="#004a33">Endereço de Entrega</Text>
                              </Box>
                              <Text fontSize="13px" color="gray.700" fontWeight="600">
                                {deliveryAddress.logradouro}, {deliveryAddressNumber}
                                {deliveryAddressComplement ? `, ${deliveryAddressComplement}` : ""}
                                {deliveryAddress.bairro ? ` — ${deliveryAddress.bairro}` : ""}
                              </Text>
                              <Text fontSize="12px" color="gray.500" mt="3px">
                                {deliveryAddress.localidade}
                                {deliveryAddress.uf ? ` — ${deliveryAddress.uf}` : ""}
                                {deliveryAddress.cep ? ` · CEP ${deliveryAddress.cep}` : ""}
                              </Text>
                              <Text fontSize="11px" fontWeight="700" color="#004a33" mt="10px">
                                🚚 Estimativa: 2 a 8 dias úteis após confirmação
                              </Text>
                            </Box>
                          )}
                      </Box>

                      <Button
                        isDisabled={isDeliveryStepCompleted}
                        background='green'
                        width="100%"
                        mt="30px"
                        onClick={(e) => paymentStepDisplay(e)}
                        bg={theme.colors.primaryGreen}
                        color={theme.colors.primaryOrange}
                        borderRadius="16px"
                        border={`1px solid ${theme.colors.primaryGreen}`}
                        _hover={{
                          background: "transparent",
                          color: `${theme.colors.primaryGreen}`,
                          borderCorlor: `${theme.colors.primaryGreen}`
                        }}
                      >
                        Ir para pagamento
                      </Button>
                    </Box>
                  </Box>
                </>)}
                {paymentStep && (<>

                    <Box
                      bg={`linear-gradient(135deg, ${theme.colors.primaryGreen} 0%, rgba(0, 74, 51, 0.95) 100%)`}
                      p="16px 20px"
                      borderBottom="none"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Text
                        fontSize="20px"
                        color={theme.colors.primaryOrange}
                        fontWeight="900"
                      >
                        Pagamento
                      </Text>
                      <Button
                        background='transparent'
                        border='1px solid transparent'
                        borderRadius="50px"
                        color={theme.colors.primaryOrange}
                        padding="0px"
                        onClick={(e) => deliveryStepDisplay(e)}
                        transform="scaleX(-1)"
                        _hover={{
                          background: "transparent",
                          color: `${theme.colors.primaryOrange}`,
                          borderCorlor: `${theme.colors.primaryOrange}`,
                          transform: "scaleX(-1) rotate(180deg)",
                        }}
                      >
                        <FaRedoAlt/>
                      </Button>
                    </Box>


                </>)}

                {paymentStep && (<Box padding="0% 1.5%">

                  <Box border={`1px solid rgba(0, 74, 51, 0.08)`} boxShadow="0 2px 8px rgba(0, 74, 51, 0.04)" p="20px" my="12px" borderRadius="12px" bg="rgba(0, 74, 51, 0.02)" >
                    <Text
                      fontSize="16px" fontWeight="500" mb="5px"
                    >
                      Creditos disponíveis: {userCredits.length > 0 && (userCredits.reduce((n, { amount }) => n + amount, 0).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})) || `R$0,00`}
                    </Text>
                    <Checkbox colorScheme='green' borderColor={theme.colors.lightGray} onChange={handleUseCreditChange}>
                      Usar créditos na compra
                    </Checkbox>
                    <Text
                      fontSize="16px" fontWeight="500" mb="5px" marginTop="20px"
                    >
                      Selecione o método de pagamento
                    </Text>
                    <Box display="grid" gridTemplateColumns={{ base: "1fr", md: "1fr 1fr" }} gap="10px" mt={1}>
                      <Box
                        as="button"
                        onClick={() => handlePaymentMethod('pix')}
                        border={paymentMethod === 'pix' ? "2px solid #004a33" : "1.5px solid rgba(0,74,51,.15)"}
                        bg={paymentMethod === 'pix' ? "rgba(0,74,51,.04)" : "white"}
                        borderRadius="14px"
                        p={4}
                        textAlign="left"
                        cursor="pointer"
                        transition="all 0.15s"
                        _hover={{ borderColor: "#004a33", bg: "rgba(0,74,51,.03)" }}
                      >
                        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                          <Box display="flex" alignItems="center" gap={2}>
                            <Text fontSize="18px">💠</Text>
                            <Text fontWeight="800" fontSize="14px" color="#004a33">PIX</Text>
                          </Box>
                          {paymentMethod === 'pix' && (
                            <Box w="18px" h="18px" borderRadius="50%" bg="#004a33"
                              display="flex" alignItems="center" justifyContent="center">
                              <Text color="#fc8f04" fontSize="9px" fontWeight="900">✓</Text>
                            </Box>
                          )}
                        </Box>
                        <Text fontSize="11px" color="gray.500" textAlign="left">Aprovação imediata</Text>
                        <Text fontSize="11px" fontWeight="700" color="green.600" mt={1} textAlign="left">Sem taxas extras</Text>
                      </Box>
                      <Box
                        as="button"
                        onClick={() => handlePaymentMethod('credit_card')}
                        border={paymentMethod === 'credit_card' ? "2px solid #004a33" : "1.5px solid rgba(0,74,51,.15)"}
                        bg={paymentMethod === 'credit_card' ? "rgba(0,74,51,.04)" : "white"}
                        borderRadius="14px"
                        p={4}
                        textAlign="left"
                        cursor="pointer"
                        transition="all 0.15s"
                        _hover={{ borderColor: "#004a33", bg: "rgba(0,74,51,.03)" }}
                      >
                        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                          <Box display="flex" alignItems="center" gap={2}>
                            <Text fontSize="18px">💳</Text>
                            <Text fontWeight="800" fontSize="14px" color="#004a33">Cartão</Text>
                          </Box>
                          {paymentMethod === 'credit_card' && (
                            <Box w="18px" h="18px" borderRadius="50%" bg="#004a33"
                              display="flex" alignItems="center" justifyContent="center">
                              <Text color="#fc8f04" fontSize="9px" fontWeight="900">✓</Text>
                            </Box>
                          )}
                        </Box>
                        <Text fontSize="11px" color="gray.500" textAlign="left">Crédito</Text>
                        <Text fontSize="11px" fontWeight="700" color="#004a33" mt={1} textAlign="left">Até 4x sem juros</Text>
                      </Box>
                    </Box>
                    <Box display={{ base: "block", md: "flex"}} alignContent="center" justifyContent="space-between" gap="10px" marginTop="20px">
                      <Box width="100%">
                        <Text fontSize="16px" fontWeight="500" mb="3px">Observações:</Text>
                        <Input
                          placeholder='Escolha o sabor ou
                          acrescente alguma info'
                          onChange={(e) => setPaymentObservations(e.target.value)}
                          h="56px"
                          mb="2"
                          borderRadius="14px"
                          marginBottom="10px"
                          autoComplete="full-name"
                          _focus={{
                            borderColor: "#fc8f04",
                            boxShadow: "0 0 0 1px #fc8f04"
                          }}
                        />
                      </Box>
                      <Box width="100%">
                        <Box marginTop='' display={{base: 'flex', md: 'flex'}} justifyContent='start' gap='3px' alignItems='center'>
                          <Text fontSize="16px" fontWeight="500" mb="3px">Cupom:</Text>
                          {validCoupon !== undefined && statusCoupon === "Ok" && (<>
                            <Text display='flex' alignItems='center' gap='3px' mb="3px" color='#004a33' fontWeight='bolder'>{statusCoupon} <FaThumbsUp></FaThumbsUp></Text>
                          </>)}

                          {validCoupon !== undefined && statusCoupon !== "Ok"  && statusCoupon !== "Não Aplicado" && (<>
                            <Text display='flex' alignItems='center' gap='3px' mb="3px" color='red' fontWeight='bolder'>{statusCoupon} <FaThumbsDown></FaThumbsDown></Text>
                          </>)}
                          {statusCoupon === "Não aplicado" && (<>
                            <Text color='black' mb="3px" >{statusCoupon}</Text>
                          </>)}
                        </Box>
                        <Input
                          placeholder='Cupom de desconto'
                          onChange={(e) => setCouponCode(e.target.value)}
                          h="56px"
                          mb="2"
                          borderRadius="14px"
                          marginBottom="10px"
                          autoComplete="full-name"
                          _focus={{
                            borderColor: "#fc8f04",
                            boxShadow: "0 0 0 1px #fc8f04"
                          }}
                        />
                      </Box>
                    </Box>

                    <Text
                      fontSize="18px" fontWeight="500" mb="5px" marginTop="30px"
                    >
                      Resumo:
                    </Text>
                    <Box>
                      {setFinalPriceForOrder(cartBatches, deliveryMethod, useCredit, userCredits, paymentMethod, couponDiscount, couponKind, products)}
                    </Box>



                    <Button
                      width="100%"
                      margin={{base: '5% 0%', md: '40px 0px 0px 0px'}}
                      borderRadius="16px"
                      bg={theme.colors.primaryGreen}
                      color={theme.colors.primaryOrange}
                      border={`1px solid ${theme.colors.primaryGreen}`}
                      isLoading={loadingPaymentProcess}
                      loadingText="Processando…"
                      _hover={{
                        background: "transparent",
                        color: `${theme.colors.primaryGreen}`,
                        borderColor: `${theme.colors.primaryGreen}`
                      }}
                      onClick={(e) => handleFinishOrder(e)}
                    >
                      Finalizar Pedido
                    </Button>
                  </Box>
                </Box>)}
              </Box>
            </Box>
            <Box gap='10px' width={{ base: "100%", lg: "32%" }} order={{base: 1, md: 2}} marginBottom={{base: '5%', md: '0%'}}
              position={{ base: "static", lg: "sticky" }}
              top="120px"
              alignSelf="flex-start"
            >
              {(cartBatches.length <= 0 && loadingPage) && (
                <Box display="flex" flexDirection="column" gap="12px" p={2}>
                  {[0, 1, 2].map(i => (
                    <Skeleton key={i} height="108px" borderRadius="20px" />
                  ))}
                </Box>
              )}
              {(cartBatches.length === 0 && !loadingPage) && (
                <Text
                  textAlign="center"
                  fontSize="18px"
                  color={theme.colors.primaryGreen}
                  fontWeight="600"
                  py='30px'
                >
                  Nenhum item adicionado ao carrinho.
                </Text>
              )}
              {cartBatches.length > 0 && (
                <Box
                  borderRadius="16px"
                  border={`1px solid rgba(0, 74, 51, 0.08)`}
                  boxShadow="0 4px 16px rgba(0, 74, 51, 0.08)"
                  bg="white"
                  overflow="hidden"
                  transition="all 0.3s ease"
                  _hover={{
                    boxShadow: "0 8px 24px rgba(0, 74, 51, 0.12)",
                    borderColor: "rgba(0, 74, 51, 0.16)"
                  }}
                >
                  <Box
                    bg={`linear-gradient(135deg, ${theme.colors.primaryGreen} 0%, rgba(0, 74, 51, 0.95) 100%)`}
                    p="16px 20px"
                    borderBottom="none"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Text
                      fontSize="20px"
                      fontWeight="900"
                      color={theme.colors.primaryOrange}
                    >
                      Resumo do Pedido
                    </Text>
                  </Box>
                  <Box p="16px">

              {cartBatches.length > 0 && cartBatches.map((cartBatch, index) => {
                return (<React.Fragment key={`item-${index}`}>
                  <Box display="flex" justifyContent="space-between" gap="5px" alignItems="center">
                    <Image
                      maxW={{ base: '100%', sm: '200px' }}
                      width="72px"
                      height="72px"
                      borderRadius="14px"
                      objectFit="cover"
                      src={photos.find(element => element.product === (batches.find(element => element.id === cartBatch.batch_id)?.product_id))?.photo || require('../../assets/images/home-cover.webp')}
                      alt='Produto'
                      maxHeight='16.5rem'
                    />
                    <Text pb='2'
                    fontWeight="700"
                    fontSize="14px"
                    noOfLines={2}
                    >{products.find(element => element.id === (batches.find(element => element.id === cartBatch.batch_id)?.product_id))?.name}</Text>

                    <Button
                      onClick={(e) => hendleRemoveCartBatch(e, cartBatch)}
                      colorScheme="red"
                      size="sm"
                      background='transparent'
                      color='red'
                      fontSize='lg'
                      _hover={{
                        background: 'transparent',
                        color: 'red'
                      }}
                    >
                      <FaRegTimesCircle></FaRegTimesCircle>
                    </Button>
                  </Box>

                  <Box my={2} display={{base: 'flex', md: 'flex'}} width='100%' justifyContent='space-between' alignItems='center'>
                    <Box display='flex' marginTop={{base: '10px', md: '0'}}  width='50%' marginBottom='0' alignItems='center' padding='5px' height="30px"
                      border="1px solid"
                      borderColor="gray.200"
                      borderRadius="999px"
                      px="8px"
                      h="40px"
                    >
                      <BsDash
                        size={24}
                        weight="fill"
                        cursor="pointer"
                        id="button-decrement"
                        onClick={(e) => handleDecrement(cartBatch)}
                      />
                      <Input
                        id={`cart${cartBatch.id}-quantity`}
                        margin={"0px"}
                        type="number"
                        width={{base: '', md: ''}}
                        padding='0%'
                        background={"transparent"}
                        fontWeight={"bold"}
                        textAlign="center"
                        border="none"
                        value={cartBatch.quantity}
                        readOnly={true}
                      />
                      <BsPlus
                        size={24}
                        weight="fill"
                        cursor="pointer"
                        margin={"auto"}
                        id="button-increment"
                        onClick={(e) => handleIncrement(cartBatch)}
                      />
                    </Box>
                    {setFinalPriceForCartBatch(cartBatch)}
                  </Box>
                  {/* {console.log(cartBatch)} */}
                  <Text mt={2} textAlign={{base: 'start', md: 'start'}} fontSize="12px">{cartBatch.quantity} {batches?.find(element => element.id === cartBatch.batch_id)?.unity_of_measurement}{cartBatch.quantity > 1 ? 's' : ''} / {cartBatch.quantity * products?.find(element => element.id === (batches?.find(element => element.id === cartBatch.batch_id)?.product_id))?.quantity_per_box} {products.find(element => element.id === (batches.find(element => element.id === cartBatch.batch_id)?.product_id))?.size}</Text>
                  <Box mb={2} display="flex" alignItems="center" gap={1}>
                    <Text fontSize="10px">🚚</Text>
                    <Text fontSize="12px" color="#004a33" fontWeight="600">{calculateDeliveryPeriod(batches?.find(element => element.id === cartBatch.batch_id), products.find(element => element.id === (batches.find(element => element.id === cartBatch.batch_id)?.product_id)), deliveryMethod, cartBatch)}</Text>
                  </Box>
                  <Divider orientation='horizontal' borderColor="gray.200" borderBottomWidth='2px' margin='10px auto'></Divider>
                </React.Fragment>);
              })}
              {totalCartAmount < 120 && (<>
                <Progress
                  margin="30px auto 5px auto"
                  borderRadius="3px"
                  colorScheme={colorScheme}
                  width="100%"
                  size="sm"
                  value={percentageOf120}
                />
                <Text textAlign="center">+ {amountLeft.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} para Frete grátis</Text>
              </>)}
              {totalCartAmount >= 120 && (
                <Box
                  bg="green.50"
                  p="16px"
                  borderRadius="14px"
                  mt="20px"
                >
                  <Text textAlign="center" color="#004a33">Frete grátis</Text>
                </Box>
              )}
              <Box display='flex' justifyContent='space-between' my='20px' mx="4px" alignItems="center">
                <Text fontSize="13px" color="gray.500">Total dos produtos</Text>
                <Text fontSize="32px" fontWeight="900" color={theme.colors.primaryGreen}>
                  {totalCartAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                </Text>
              </Box>
              <Box bg="rgba(0,74,51,.04)" borderRadius="12px" p={3} mx="4px" mb={3} border="1px solid rgba(0,74,51,.08)">
                <Box display="flex" alignItems="flex-start" gap={2}>
                  <Text fontSize="15px" flexShrink={0}>🚚</Text>
                  <Box>
                    <Text fontSize="12px" fontWeight="700" color="#004a33">Prazo de Entrega</Text>
                    <Text fontSize="11px" color="gray.500" mt={0.5}>
                      {deliveryMethod === 'collect'
                        ? 'Retirada: a partir de 8 dias úteis'
                        : 'Entrega: 2 a 8 dias úteis após o pagamento'}
                    </Text>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          )}
        </Box>
          </Box>
        </Box>
      </Box>
      <Footer />
    </Box>
  )
}
